module.exports = __webpack_public_path__ + "img/18_83.1fe39a80.png";